export interface FundHistoryData {
    active: number
    total: number
    pageSize: number
    pageNum: number
    tabList: any[]
    dataLog: CardDataItem[]
}

export interface CardDataItem {
    createTime: string,
    amount: number | string,
    status: number,
    afterBalance: number,
    type: string
}

export const FUNDS_TABS = [
    { name: 'fund.recharge', id: 2 },
    { name: 'fund.withdraw', id: 3 },
    { name: 'fund.fundFlowLog', id: 1 },
]

export const PAGE_SIZE = 20

export const setRechargeStatus = (status: number) => {
    if (status === 0) {
        return 'fund.pending'
    } else if (status == 1) {
        return 'fund.notCompleted'
    } else if (status == 2) {
        return 'fund.completed'
    } else if (status == 3) {
        return 'fund.rejected'
    } else {
        return ""
    }
}

export const setWithdrawStatus = (status: number) => {
    if (status === 0) {
        return 'fund.awaitingReveiw'
    } else if (status == 1) {
        return 'fund.notCompleted'
    } else if (status == 2) {
        return 'fund.completed'
    } else if (status == 3) {
        return 'fund.rejected'
    } else {
        return ""
    }
}